import React from "react";
import ReactDOM from "react-dom/client"; // <-- Use ReactDOM from "react-dom/client"
import "./index.css";
import "bootstrap-scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// Select the node that will be observed for mutations
const targetNode = document;

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = function (mutationsList, observer) {
  let classIntroAppRoot = document.querySelector("#askh_intro_class_app");
  for (const mutation of mutationsList) {
    if (!classIntroAppRoot.ready) {
      classIntroAppRoot.ready = true;
      
      // ✅ Use ReactDOM.createRoot() instead of ReactDOM.render()
      const root = ReactDOM.createRoot(classIntroAppRoot);
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
    }
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

// If you want your app to work offline and load faster, change unregister() to register()
serviceWorker.unregister();
